
export const normalizePaginatedResponse = (data, offset, limit) => ({
  items: data?.items ?? [],
  offset: Number(data?.offset ?? offset),
  count: Number(data?.count ?? data?.items?.length ?? 0), 
  limit: Number(data?.limit ?? limit),
});

export const cleanFilters = (filters) => {
  return Object.fromEntries(
    Object.entries(filters).filter(
      ([, value]) => value !== undefined && value !== null && value !== ''
    )
  );
};